import LookupResourceChip from "./LookupResourceChip";

export default LookupResourceChip;
